// extracted by mini-css-extract-plugin
module.exports = {"Magnify":"Search_Magnify__7EX4e","Input":"Search_Input__VEKoy"};